import React from "react";
import Highlight from "react-highlight";
import { FunctionDependency, Node } from "../../types";
import getDependencyLabel from "../../util/getDependencyLabel";

type Props = {
  node: Node;
  nodes: Node[];
};

/**
 * Represents a single section on the function documentation.
 *
 * @author Juhana Kuparinen <juhana.kuparinen@kvanttori.fi>
 */

const ProcessSection = ({ node, nodes }: Props) => {
  const funcs =
    node.functions &&
    node.functions.map((f, index) => {
      const keys = f.functionVariables ? Object.keys(f.functionVariables) : [];

      const dependencies = keys
        .map(dependencyLabel => {
          let dependencyMappings: FunctionDependency[];

          // We force dependency mappings to always be an array
          if (!Array.isArray(f.functionVariables[dependencyLabel])) {
            dependencyMappings = [
              f.functionVariables[dependencyLabel] as FunctionDependency,
            ];
          } else {
            dependencyMappings = f.functionVariables[
              dependencyLabel
            ] as FunctionDependency[];
          }

          return dependencyMappings.map(
            (dependency: FunctionDependency, key: number) => (
              <tr
                key={`${dependencyLabel} - ${key} -${
                  dependency.data[dependency.data?.length - 1]
                }`}
              >
                <td>{dependencyLabel}</td>
                <td>{getDependencyLabel(dependency, node, nodes)}</td>
              </tr>
            )
          );
        })
        .flat();

      return (
        <article key={`${node.id}-${f.label}-${index}`}>
          <h3 id={`${node.name}-${f.label}`}>{f.label}</h3>
          <p>{f.description ?? ""}</p>
          <div className="be_code-block">
            <Highlight className="language-javascript">
              {f.function ?? "Functions enabled but no functions found"}
            </Highlight>
          </div>
          {dependencies.length ? (
            <>
              <h4>Dependencies</h4>
              <table className="be_fields">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Assigned to</th>
                  </tr>
                </thead>
                <tbody>{dependencies}</tbody>
              </table>
            </>
          ) : null}
        </article>
      );
    });

  return (
    <section className="be_process-section">
      <h2 id={node.name}>{node.name}</h2>
      <hr />
      {funcs}
    </section>
  );
};

export default ProcessSection;
